document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const formPlaceholder = document.querySelector(".jdgm-review-widget");
    const writeReviewBtn = document.querySelector(".jdgm-write-rev-link");

    if (formPlaceholder && writeReviewBtn) {
      clearInterval(interval);

      writeReviewBtn.style.display = "none";

      const formScript = document.createElement('script');
      formScript.src = `https://cdn.judge.me/reviews_widget/review_form.js?shop=ecoheads-v1.myshopify.com&product_id=${formPlaceholder.getAttribute("data-id")}`;
      document.body.appendChild(formScript);
    }
  }, 500);
});



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".w-tab-pane").forEach((panel) => {
    const hotspots = panel.querySelectorAll("[data-hotspot]");
    const contents = panel.querySelectorAll("[data-hotspot-content]");

    function showHotspotContent(index) {
      contents.forEach((content) => {
        content.style.display = "none";
        content.classList.remove("fade-in-up");
      });

      const activeContent = panel.querySelector(`[data-hotspot-content="${index}"]`);
      if (activeContent) {
        activeContent.style.display = "block";

        void activeContent.offsetWidth;
        activeContent.classList.add("fade-in-up");
      }

      hotspots.forEach((hotspot) => hotspot.classList.remove("active"));

      const activeHotspot = panel.querySelector(`[data-hotspot="${index}"]`);
      if (activeHotspot) {
        activeHotspot.classList.add("active");
      }
    }

    hotspots.forEach((hotspot) => {
      hotspot.addEventListener("click", function () {
        const index = this.getAttribute("data-hotspot");
        showHotspotContent(index);
      });
    });

    showHotspotContent("1");
  });
});



document.getElementById('cleansers-open').addEventListener('click', function(e) {
  e.preventDefault();
  document.getElementById('cleansers-tab').click();
});



document.getElementById('tones-open').addEventListener('click', function(e) {
  e.preventDefault();
  document.getElementById('tones-tab').click();
});



document.getElementById('tones-open-2').addEventListener('click', function(e) {
  e.preventDefault();
  document.getElementById('tones-tab').click();
});



document.getElementById('care-open').addEventListener('click', function(e) {
  e.preventDefault();
  document.getElementById('care-tab').click();
});



document.getElementById('hardware-open').addEventListener('click', function(e) {
  e.preventDefault();
  document.getElementById('hardware-tab').click();
});
